{
  "Description": "10-Digits - NNNNNNNNNN",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[0-9]{10}$",
  "TestData": {
    "Valid": [
      "1234567890",
      "5678567833"
    ],
    "Invalid": [
      "12334545698",
      "123s33s12",
      "123456789"
    ]
  }
}
